import { faker } from '@faker-js/faker';

import type { BankDetailsPostResponse } from '../types/BankDetailsPostResponse';

export function createBankDetailsPostResponse(
  data: NonNullable<Partial<BankDetailsPostResponse>> = {}
): NonNullable<BankDetailsPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
